<template>
    <div id="header-top" class="container-fluid">
      <div v-if="logoutSplash" class="logout-splash">
        <span>{{ logoutMessage }}</span>
      </div>
        <div class="row">
            <div class="header navbar fixed-top navbar-default">
    
                <!-- Logo -->
                <span class="logo" id="logo">
                    <router-link to="/">
                      <span style="font-size: 24px;">⟵</span>
                    </router-link>
                </span>
                <!-- MENUS -->
                <div class="d-md-flex align-items-center gap-0">
                
                </div>
    
                <!-- Top Menu (Responsive Dropdown) -->
                <div class="login-container" v-if="userid == null">
                    <router-link to="/login" class="login-register">
                        <i class="fa fa-sign-in-alt"></i> Login
                    </router-link>
                    <router-link to="/register" class="login-register">
                        <i class="fa fa-user-plus"></i> Register
                    </router-link>
                </div>
    
                <div class="bell-profile dropdown" v-if="userid != null">
                    <span class="bell">
                      <img src="../../assets/notification-icon.svg" alt="">
                    </span>
                    <span class="profile dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <i class="fa fa-user"></i>&nbsp; {{ username }}
                    </span>
                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                    <router-link v-if="user_role === 'escort' || user_role === 'content-creator'" class="dropdown-item" :to="'/profile/' + userid + '/'+ username">My Profile</router-link>
                    <router-link v-if="user_role === 'guest'" class="dropdown-item" :to="'/guest-profile/' + userid + '/'+ username">My Profile</router-link>
                    <router-link class="dropdown-item" :to="'/add-bank/' + userid + '/'+ username">Add Banks</router-link>
                    <router-link class="dropdown-item" to="#"> <span @click="logout">Logout</span> </router-link>
                    </div>
                </div>
            </div>
            
        </div>
    
        <div class="row">
            <div class="col-md-1">
            </div>
            <div class="col-md-10">
                <router-view />
            </div>
            <div class="col-md-1">
            </div>
        </div>
        <hr style="color: #fff;">
        <footer class="footer text-white py-5">
            <div class="row text-md-left align-items-start">
              
              <!-- Logo & Description -->
              <div class="col-md-4 mb-4">
                <router-link to="/">
                  <img src="/logo.png" alt="Dayruns" width="120" class="mb-2" />
                </router-link>
                <p class="small">
                  Discover premium models, private rooms, and entertainment. Your trusted lifestyle companion.
                </p>
              </div>
    
              <!-- Categories -->
              <div class="col-md-2 mb-4">
                <h5 class="footer-title">Categories</h5>
                <ul class="list-unstyled">
                  <li><router-link to="/escorts" class="footer-link">Models</router-link></li>
                  <li><router-link to="/rooms" class="footer-link">Rooms</router-link></li>
                  <li><router-link to="/galleries" class="footer-link">Galleries</router-link></li>
                  <li><router-link to="/videos" class="footer-link">Videos</router-link></li>
                </ul>
              </div>
    
              <!-- Support -->
              <div class="col-md-3 mb-4">
                <h5 class="footer-title">Support</h5>
                <ul class="list-unstyled">
                  <li><router-link to="/help" class="footer-link">Help Center</router-link></li>
                  <li><router-link to="/terms" class="footer-link">Terms of Service</router-link></li>
                  <li><router-link to="/privacy" class="footer-link">Privacy Policy</router-link></li>
                </ul>
              </div>
    
              <!-- Social Media -->
              <div class="col-md-3 mb-4">
                <h5 class="footer-title">Follow Us</h5>
                <div>
                  <a href="#" class="footer-social mr-3"><i class="fab fa-facebook-f"></i></a>
                  <a href="#" class="footer-social mr-3"><i class="fab fa-twitter"></i></a>
                  <a href="#" class="footer-social"><i class="fab fa-instagram"></i></a>
                </div>
              </div>
            </div>
    
            <!-- Bottom Line -->
            <div class="text-center mt-4 border-top pt-3">
              <small>© {{ new Date().getFullYear() }} Dayruns App. All rights reserved.</small>
            </div>
        </footer>
        <a href="#header-top">  
          <div class="header-top">
              <i class="fa fa-arrow-up"></i>
          </div>  
        </a>   
    </div>    
    </template>
    <script>
    //import swal from 'sweetalert2';
    import $ from 'jquery';
    export default {
        
        data() {
        return {
            myprofile: '',
            app_role: '',
            is_chat: 0,
            userid: '',
            username: '',
            isChat:'',
            logoutSplash: false,
            logoutMessage: "",
            user_role: ''
        };
      },
    
      beforeMount(){
           
            //this.newMessages();
        },
        mounted() {
            this.app_role = localStorage.getItem("role");
            this.userid = localStorage.getItem("userid");
            this.isChat = localStorage.getItem("isChat");

            this.listMyProfile(this.userid); 
    
            $(document).ready(function() {
            $(window).scroll(function() {
                if ($(this).scrollTop() > 100) {
                    $('.header-top').fadeIn();
                  document.getElementById('top-header').style.display = 'none'
                  
                } else {
                    $('.header-top').fadeOut();
                    if ($(this).scrollTop() == 0) {
                        document.getElementById('top-header').style.display = 'flex'
                    }
                }
              
            });
    
            $('.header-top').click(function() {
                $('html, body').animate({scrollTop: 0}, 800);
                return false;
                });
            });
    
            setInterval(() => {
                this.showImage = this.showImage === 2 ? 1 : this.showImage + 1;
            }, 10000); // Toggle images every 3 seconds
    
        },
        created(){
      
        },
    
    
      methods: {
        showSidebar() {
            this.showMobileMenu = !this.showMobileMenu;
        },
       
        profile() {
            document.getElementById("profile").classList.add('profile-menu');
        },
        
        async listMyProfile(userid){
         try{
            const response = await this.$http.post('/list-profile', 
            { user_id: userid},
            {
            headers: { 
                //"x-api-key": `${process.env.VUE_APP_API_KEY}`,
                'Content-Type': 'application/json' 
            }
            }
            )
            this.myprofile = response.data.data;
            this.username =  this.myprofile[0]?.username
                      
            }catch (err) {
            console.log(err);
        }
    },
        async newMessages(){
             try{
                const response = await this.$http.get('/new-messages', )
                this.is_chat = response.data.chat_count;
                          
                }catch (err) {
                console.log(err);
            }
        },
        async logout() {
        const confirmLogout = confirm("You are about to log out. Are you sure?");
        if (confirmLogout) {
          try {
            this.response = await this.$http.post('/logout');

            // Set splash message
            this.logoutMessage = this.response.data.message || "Logged out successfully!";
            this.logoutSplash = true;

            // Clear local storage
            localStorage.removeItem("userid");
            localStorage.removeItem("role");
            localStorage.removeItem("email");
            localStorage.removeItem("isChat");

            // Wait before redirecting
            setTimeout(() => {
              this.logoutSplash = false;
               window.location.href = '/';
            }, 2500); // splash visible for 2.5 seconds
          } catch (err) {
            console.error("Logout failed:", err);
          }
        }
      }
      },
        
    }
    </script>
    <style lang="scss" scoped>
    @import url('https://fonts.googleapis.com/css2?family=DM+Sans&family=Raleway&display=swap');
    .logout-splash {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      font-family: 'Raleway';
      font-style: normal;
      background-color: #0A070F; /* green success */
      color: white;
      padding: 15px;
      text-align: center;
      font-weight: bold;
      z-index: 9999;
      box-shadow: 0 2px 5px rgba(0,0,0,0.3);
      transition: top 0.3s ease-in-out;
    }

    .mobile-nav {
      display: flex;
      flex-direction: column;
      position: absolute;
      top: 60px; /* adjust if header height differs */
      left: 0;
      right: 0;
      z-index: 999;
      background: #0A070F !important;
    }
    
    .mobile-nav .nav-link-mobile {
      font-size: 12px;
      padding: 0px;
    }
    .mobile-nav i {
      font-size: 18px;
    }
    
    .mobile-menu{
        padding: 0px 15px 0px 20px;
        background: #0A070F;
        margin: 0px;
        font-size: 14px;
    }
    
    .nav-link-mobile{
        display: flex;
        flex-direction: row;
        justify-content: left;
        align-items: center;
        margin: 20px 15px;
        font-size: 14px;
    }
    .nav-link-mobile small{
        font-size: 18px !important;
    }
    .login-register{
        margin: 0 4px;
        color: #FFFFFF;
        text-decoration: none;
    }
    
    .nav-link {
        margin: 0 15px;
        color: #FFFFFF;
        text-decoration: none;
    }
    .nav-link:hover {
        color: #0A070F;
    }
    .gap-4 {
        gap: 1.5rem;
    }
    
    
    h2 {
        color: #FFF;
    }
    .main {
        background: #0A070F;
        width: 100%;
        min-height: 100vh;
    }
    .space{
        padding: 10px 10px 0px 30px;
    }
    .container {
        padding: 10px 10px 10px 50px;
        background: transparent;
    }
    .container-fluid{
        width: 100%;
        min-height: 100vh;
        background: #0A070F;
    
        .bar {
            display: none;
        }
        .button {
            display: none;
          }
        .btn-close{
            display: none;
        }
        .window-close{
            display: none
        }
    
        @media screen and (max-width: 768px){
            .logo {
                display:flex;
            }
            .bar {
                display: block;
                height: 5px;
                width: 40px;
                background-color: #D33E74;
                margin: 6px auto;
              }
              .button {
                cursor: pointer;
                display: inline-block;
                width: auto;
                margin: 0 auto;
                -webkit-transition: all .7s ease;
                -moz-transition: all .7s ease;
                -ms-transition: all .7s ease;
                -o-transition: all .7s ease;
                transition: all .7s ease;
                margin-left: 0px;
    
              }
              .btn-close{
                margin-left: 25px;
                margin-top: -20px;
                .close{
                    width: 42px;
                    height: 40px;
                }
    
              }
              .bar {
                -webkit-transition: all .7s ease;
                -moz-transition: all .7s ease;
                -ms-transition: all .7s ease;
                -o-transition: all .7s ease;
                transition: all .7s ease;
              }
            .sidebar {
                height: 100vh;
                padding: 4rem 1rem;
            }
    
        }
        .header {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            padding: 0px 20px 0px 20px;
            height: 70px;
            background: #D33E74;
            width: 100%;   
            font-size: 13px;   
            font-weight: 400; 
        
            .logo > a{
              color: #fff;
              text-decoration: none;
            }
            .login-container{
                display: flex;
                justify-content: right;
                align-items: center;
            }
            .bell-profile {
                display: flex;
                justify-content: center;
                align-items: center;
    
                .bell {
                  padding: 5px;
                  border-radius: 44px;
                  background: #fff;
                  cursor: pointer;
                }
    
            }
            .dropdown-menu {
                background: #0A070F;
                color:#ccc; 
                font-size: 16px;
            }
            .dropdown-menu > a {
                background: #312F33;
                color:#ccc; 
            }
            .dropdown-menu:hover {
                //background: #ccc;
                color:#0A070F; 
            }
          
            .profile{
                display: flex;
                flex-direction: row;
                justify-content: center;
                align-items: center;
                padding: 10px;
                width: auto;
                height: 35px;
                background: #D33E74;
                border-radius: 82px;
                font-family: 'Source Sans 3';
                font-style: normal;
                font-weight: 600;
                font-size: 12px;
                line-height: 28px;
                color: #FFFFFF;
                margin-top: -8px;
                
    
            }
         }
         @media screen and (max-width: 768px) {
            .header {
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                align-items: center;
                padding: 0px 20px 0px 20px;
                height: 70px;
                background: #D33E74;
                width: 100%;       
            
                .logo > img{
                    width: 120px;
                    height: 30px;
                }
                .bell-profile {
                    display: flex;
                    align-items: center;
                   // margin: 4px;
        
                    .bell {
                        padding: 5px;
                        border-radius: 44px;
                        background: #fff;
                    }
                  
                }
                .dropdown-menu {
                    background: #0A070F;
                    color:#ccc; 
                }
                .dropdown-menu > a {
                    background: #312F33;
                    color:#ccc; 
                }
                .dropdown-menu:hover {
                    //background: #ccc;
                    color:#0A070F; 
                }
              
                .profile{
                    display: flex;
                    flex-direction: row;
                    justify-content: center;
                    align-items: center;
                    padding: 10px;
                    width: auto;
                    height: 35px;
                    background: #D33E74;
                    border-radius: 82px;
                    font-family: 'Source Sans 3';
                    font-style: normal;
                    font-weight: 600;
                    font-size: 12px;
                    line-height: 28px;
                    color: #FFFFFF;
                    margin-top: -8px;
                    
        
                }
             }
            .sidebar {
                display:none;
            }
            .sidebar {
                height: 100vh;
                padding: 4rem 1rem;
                //margin-right: 100px;
            }
            .mobile-menu{
              margin-top: 50px;
            }
            .mobile-menu.text-dark:hover{
                color: #D33E74 !important;
            }
            .text-dark:hover{
                color: #D33E74 !important;
            }
            .mobile-nav:hover{
                color: #D33E74 !important;
            }
        }
         
         .sidebar {
            height: 100vh;
            padding: 4rem 1rem;
            margin-right: 100px;
        }
          .sidebar a {
            display: block;
            color: white;
            padding: 16px;
            text-decoration: none;
          }
           
          .sidebar a.active {
            background-color: #0A070F;
            color: white;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            padding: 0px;
            width: 50px;
            height: 50px;
            background: #312F33;
            border-radius: 47px;
            margin: 20px;
          }
          .sidebar a:hover{
            background-color: #D33E74;
          }
          .profile-menu{
            background-color: #D33E74;
          }
         
          .hangout a:hover {
            background-color: #FFFFFF !important;
          }
          .game a:hover {
            background-color: #FFFFFF !important;
          }
          
          @media screen and (max-width: 700px) {
            .sidebar {
              width: auto;
              height: auto;
              position: fixed;
              z-index: 9998;
              transition: opacity .4s ease;
              background-color: rgba(0, 0, 0, .5);
              .window-close{
                display: block;
                color: #FFF;
                margin-left: 35px;
              }
            }
            .sidebar a {float: left;}
            div.content {margin-left: 0;}
          }
          
          @media screen and (max-width: 400px) {
            .sidebar a {
              text-align: center;
              float: none;
            }
          }
    
    }
    
    @media screen and (max-width: 768px) { 
        .container-fluid{
            width: 100%;
            min-height: 100vh;
            background: #0A070F;
        }
        .main{
            background: #0A070F;
            width: 100%;
            height: 100vh;    
        }
    }
    .footer{
        text-align: center;
        padding: 0 20px 0 20px;
        background: #0A070F;
    }
    .footer-title{
      font-size: 18px;
    }
    .footer-link{
      color: #D33E74;
      font-size: 12px;
    }
    .footer-social{
      color: #D33E74;
    }
    .footer a {
      text-decoration: none;
      transition: color 0.2s ease-in-out;
    }
    .footer a:hover {
      color: #ff66a6;
    }
    
    @media screen and (max-width: 768px) { 
    .footer{
        text-align: left;
        padding: 0 0 0 20px;
      
    }
    }
    
    .modal-window {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: 999;
        visibility: hidden;
        opacity: 0;
        pointer-events: none;
        transition: all 0.3s;
        &:target {
          visibility: visible;
          opacity: 1;
          pointer-events: auto;
        }
        & > div {
          width: 580px;
          height: 505px;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          padding: 2em;
          border: 1px solid #2F2F2F;
          backdrop-filter: blur(13px);
          background: url(../../assets/modal_bg.png) no-repeat fixed center, #0A070F;
          box-sizing: border-box;
        }
        header {
          font-weight: bold;
        }
        h1 {
          font-size: 150%;
          margin: 0 0 15px;
        }
        h2 {
            font-family: 'Raleway';
            font-style: normal;
            font-weight: 500;
            font-size: 24px;
            line-height: 23px;
            text-align: center;
            color: #FFFFFF;
        }
        .welcome {
            margin-top: 8px;
            font-family: 'Raleway';
            font-style: normal;
            font-weight: 500;
            font-size: 14px;
            line-height: 23px;
            text-align: center;
            color: #FFFFFF;
        }
        label {
            text-align: left;
            color: #fff;
            font-size: 12px;
            margin-left:15px;
            margin-bottom: -6px;
        }
        span {
            margin-bottom: 20px;
        }
    
      }
      
      .modal-close {
        color: #fff;
        line-height: 50px;
        font-size: 140%;
        position: absolute;
        right: 0;
        text-align: center;
        top: 2;
        width: 70px;
        text-decoration: none;
        &:hover {
          color: black;
        }
      }
      .modal-close-mobile {
        color: #fff;
        line-height: 50px;
        font-size: 140%;
        position: absolute;
        right: 0;
        text-align: center;
        top: 2;
        width: 70px;
        text-decoration: none;
        &:hover {
          color: black;
        }
        display: none;
      }
      .modal-window {
        & > div {
            border-radius: 63px;
        }
      }
      .modal-logo {
        text-align: center;
        margin-top: -10px;
      }
      .modal-logo > img {
        width: 100px;
        
    }
    h2 {
       
        font-family: 'Raleway';
        font-style: normal;
        font-weight: 800;
        font-size: 10px;
        line-height: 42px;
        text-align: center;
        color: #FFFFFF;
        line-height: 190%;
        margin-top: 0px;
    
    }
    .modal-box {
        display: flex;
        flex-direction: row;
        align-items: center;
        padding: 10px 52px;
        width: 380px;
        height: 50px;
        background: #FFFFFF;
        border-radius: 50px;
        margin: 2%;
        cursor: pointer;
    }
    .login-modal-box {
        box-sizing: border-box;
        display: flex;
        flex-direction: row;
        align-items: center;
        padding: 10px 52px;
        gap: 311px;
        width: 496px;
        height: 45px;
        background: #0A070F;
        border: 0.5px solid #FFFFFF;
        border-radius: 50px;
        margin: 10px;
        color: #767475;
    }
    .btn-login {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        padding: 10px;
        gap: 10px;
        background: #D33E74;
        border-radius: 82px;
        margin-top: 8px;
        color: #fff;
        margin-left: 10px;
        
    }
    
    .header-top {
      position: fixed;
      bottom: 20px;
      right: 20px;
      z-index: 9999;
      background: #D33E74;
      color: #fff;
      border-radius: 50%;
      width: 50px;
      height: 50px;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: visibility 0.5s, opacity 0.5s;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
    }
    
    .header-top i {
      font-size: 18px;
      color: #fff;
    }
    
    .header-top:hover {
      background: #c1275e;
    }
    
    
    </style>